<div class="alignment-tools">
  <div class="alignment-buttons">
    <div class="alignment-group">
      <button class="alignment-btn" (click)="onBringToFront()" [matTooltip]="'Bring to front'">
        <mat-icon>vertical_align_top</mat-icon>
      </button>

      <button class="alignment-btn" (click)="onBringForward()" [matTooltip]="'Bring forward'">
        <mat-icon>arrow_upward</mat-icon>
      </button>

      <button class="alignment-btn" (click)="onSendBackward()" [matTooltip]="'Send backward'">
        <mat-icon>arrow_downward</mat-icon>
      </button>

      <button class="alignment-btn" (click)="onSendToBack()" [matTooltip]="'Send to back'">
        <mat-icon>vertical_align_bottom</mat-icon>
      </button>
    </div>
  </div>
</div>
